import { render } from "./view_personal_profile.html?vue&type=template&id=2487ba0f&external"
import script from "./view_personal_profile.js?vue&type=script&lang=js&external"
export * from "./view_personal_profile.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__